module.exports = __webpack_public_path__ + "assets/img/banner10.c554f256.png";